import * as React from 'react';
import { PublicationType } from "models/ApiEnums";
import HtmlUtils from 'lib/HtmlUtils';
import CreateAnswer from 'views/Publication/CreateAnswer';
import CreateCourse from 'views/Publication/CreateCourse';
import CreateList from 'views/Publication/CreateList';
import CreatePost from "views/Publication/CreatePost";
import CreatePoll from 'views/Publication/CreatePoll';
import CreateQuestion from 'views/Publication/CreateQuestion';
import { SavePublicationResult } from 'models/ApiModels';
import { RoutePaths } from 'routes/RouteConfig';

export function publicationFactory(
    publicationId: string,
    publicationType: PublicationType,
    onClose: (result: SavePublicationResult) => void,
    options: any = null
): JSX.Element {

    switch (publicationType) {
        case PublicationType.Answer:
            return (<CreateAnswer answerId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.Course:
            return (<CreateCourse publicationId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.List:
            return (<CreateList publicationId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.Poll:
            return (<CreatePoll publicationId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.Post:
            return (<CreatePost publicationId={publicationId} onClose={onClose} {...options} />);
        case PublicationType.Question:
            return (<CreateQuestion publicationId={publicationId} onClose={onClose} {...options} />);
    }

    alert('Publication Factory cannot create publication type: ' + PublicationType[publicationType]);

    return null;
}

export function getPublicationUrl(publicationId: string, publicationType: PublicationType, parentPublicationId: string = null): string {
    switch (publicationType) {
        case PublicationType.Answer:
            return `/Publication/QuestionViewer/${parentPublicationId}/${publicationId}`;
        case PublicationType.Course:
            return `/Publication/CourseViewer/${publicationId}`;
        case PublicationType.List:
            return `/Publication/ListViewer/${publicationId}`;
        case PublicationType.Poll:
            return `/Publication/PollViewer/${publicationId}`;
        case PublicationType.Post:
            return `/Publication/PostViewer/${publicationId}`;
        case PublicationType.Question:
            return `/Publication/QuestionViewer/${publicationId}`;
        default:
            return null;
    }
}

export function getUserProfileUrl(userId: string) {
    return `/User/Profile/${userId}`;
}

export function getTopicUrl(topicId: string) {
    return `/Topic/TopicViewer/${topicId}`;
}

export function getPublicationSecondViewAction(publicationType: PublicationType, publicationId: string, parentPublicationId: string = null, qs: string = null, title: string = null, forceNewWindow: boolean = false): () => void {
    var url = getPublicationUrl(publicationId, publicationType, parentPublicationId);
    if (qs) {
        let found = false;

        if (publicationType == PublicationType.Question && title != null && title.length > 0) {
            // Verifica se o título da questão contém alguma das palavras usadas na busca.
            // Se tiver, a visualização da questão será 'padrão' (sem os termos de busca).
            const auxTitle = title.toLowerCase();
            const auxqs = qs.toLowerCase().split(' ');
            for (let i = 0; i < auxqs.length && !found; i++) {
                if (auxTitle.indexOf(auxqs[i]) > -1) {
                    found = true;
                }
            }
        }

        if (!found) url += "?qs=" + qs;
    }

    return url == null
        ? () => { alert("Não foi possível determinar a página de visualização da publicação: " + publicationId + " " + publicationType); }
        : () => { HtmlUtils.openUrlInNewWindow(url, publicationId, { forceNewWindow }); };
}

export function getTopicSecondViewAction(topicId: string, forceNewWindow: boolean = false): () => void {
    return () => { HtmlUtils.openUrlInNewWindow(RoutePaths.TopicViewer.replace(":id", topicId), null, { forceNewWindow }); };
}

